import Vue from 'vue';
import Flickity from 'vue-flickity';
import 'flickity-fade';

Flickity.beforeDestroy = undefined;
Vue.component('flickity', Flickity);
